import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const EditDepartmentModal = ({ show, handleClose, data, handleSave }) => {
  const [form, setForm] = useState(data);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Department</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              value={form.name}
              onChange={(e) =>
                setForm({ ...form, name: e.target.value })
              }
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={form.status}
              onChange={(e) =>
                setForm({ ...form, status: e.target.value })
              }
            >
              <option>Active</option>
              <option>Inactive</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          style={{ background: "#f97316", border: "none" }}
          onClick={() => handleSave(form)}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditDepartmentModal;